module.exports = __webpack_public_path__ + "static/ricepaper@2x.2fb78c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/ricepaper@2x.png
// module id = 1171
// module chunks = 168707334958949